import {
  GetCmsClasesAsignables,
  GetCmsProductosOperacion,
  PostCmsAsignacion,
  PutCmsOmitirCaducidad,
  GetCmsHistorialDocumentos,
  PutCmsRecuperarDocumento
} from "../../../reducers/comisionesV2";

export interface BAsignacionStore
  extends GetCmsClasesAsignables,
    GetCmsProductosOperacion,
    PostCmsAsignacion,
    PutCmsOmitirCaducidad,
    GetCmsHistorialDocumentos,
    PutCmsRecuperarDocumento {
  archivoRefreshLoading: boolean;
  archivoRefresh: any;
  cincelFirmasLoading: boolean;
}

export const bAsignacionStore: (state) => BAsignacionStore = state => {
  const { comisionesV2, expedientes } = state;
  return {
    cmsClasesAsignables: comisionesV2.cmsClasesAsignables,
    gettingCmsClasesAsignables: comisionesV2.gettingCmsClasesAsignables,
    gettingCmsClasesAsignablesError:
      comisionesV2.gettingCmsClasesAsignablesError,

    cmsProductosOperacion: comisionesV2.cmsProductosOperacion,
    gettingCmsProductosOperacion: comisionesV2.gettingCmsProductosOperacion,
    gettingCmsProductosOperacionError:
      comisionesV2.gettingCmsProductosOperacionError,

    postingCmsAsignacion: comisionesV2.postingCmsAsignacion,
    postingCmsAsignacionError: comisionesV2.postingCmsAsignacionError,

    archivoRefreshLoading: expedientes.archivoRefreshLoading,
    archivoRefresh: expedientes.archivoRefresh,

    cincelFirmasLoading: expedientes.cincelFirmasLoading,

    puttingCmsOmitirCaducidad: comisionesV2.puttingCmsOmitirCaducidad,
    puttingCmsOmitirCaducidadMessage:
      comisionesV2.puttingCmsOmitirCaducidadMessage,
    puttingCmsOmitirCaducidadError: comisionesV2.puttingCmsOmitirCaducidadError,

    cmsHistorialDocumentos: comisionesV2.cmsHistorialDocumentos,
    gettingCmsHistorialDocumentos: comisionesV2.gettingCmsHistorialDocumentos,
    gettingCmsHistorialDocumentosError:
      comisionesV2.gettingCmsHistorialDocumentosError,

    puttingCmsRecuperarDocumento: comisionesV2.puttingCmsRecuperarDocumento,
    puttingCmsRecuperarDocumentoError:
      comisionesV2.puttingCmsRecuperarDocumentoError
  };
};
